export const STORED_SETTINGS ='everything-book settings';
export const STORED_USER ='everything-book user';
